if (!window.EcoScentProductCompareDiffusers) {
  window.EcoScentProductCompareDiffusers = {
    sectionSelector: '.product-compare-diffusers-section',
    trackSelector: '[data-product-compare-track]',

    updateProgressBar: function (track, progressBar) {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const scrolledRatio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      const barScale = Math.max(0.15, Math.min(1, track.clientWidth / track.scrollWidth));

      progressBar.style.transform = 'scaleX(' + barScale + ')';
      progressBar.style.marginLeft = scrolledRatio * (1 - barScale) * 100 + '%';
    },

    initTrack: function (section, track) {
      const namespace = window.EcoScentProductCompareDiffusers;
      const progressBar = section.querySelector('[data-product-compare-progress]');
      if (!progressBar) return;

      const update = function () {
        namespace.updateProgressBar(track, progressBar);
      };

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      if (typeof ResizeObserver === 'function') {
        new ResizeObserver(update).observe(track);
      }

      update();
    },

    initSection: function (section) {
      const namespace = window.EcoScentProductCompareDiffusers;
      if (section.dataset.productCompareReady === 'true') return;
      section.dataset.productCompareReady = 'true';

      section.querySelectorAll(namespace.trackSelector).forEach(function (track) {
        namespace.initTrack(section, track);
      });
    },

    initAllSections: function (root) {
      const namespace = window.EcoScentProductCompareDiffusers;
      (root || document).querySelectorAll(namespace.sectionSelector).forEach(namespace.initSection);
    },

    handleSectionLoad: function (event) {
      window.EcoScentProductCompareDiffusers.initAllSections(event.target);
    },

    listen: function () {
      const namespace = window.EcoScentProductCompareDiffusers;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { namespace.initAllSections(); });
      } else {
        namespace.initAllSections();
      }
      document.addEventListener('shopify:section:load', namespace.handleSectionLoad);
    },
  };

  window.EcoScentProductCompareDiffusers.listen();
}
